import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/base/ScrollReveal';

const INCLUDES_ITEMS = [
  { icon: 'ri-building-4-line', key: 'includes1' },
  { icon: 'ri-briefcase-4-line', key: 'includes2' },
  { icon: 'ri-advertisement-line', key: 'includes3' },
  { icon: 'ri-slideshow-3-line', key: 'includes4' },
  { icon: 'ri-radar-line', key: 'includes5' },
  { icon: 'ri-rocket-2-line', key: 'includes6' },
  { icon: 'ri-user-search-line', key: 'includes7' },
  { icon: 'ri-line-chart-line', key: 'includes8' },
  { icon: 'ri-settings-3-line', key: 'includes9' },
  { icon: 'ri-bar-chart-2-line', key: 'includes10' },
  { icon: 'ri-folder-check-line', key: 'includes11' },
];

export default function Includes() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-50 text-primary-700 text-xs font-semibold tracking-wider uppercase mb-4">
              {t('trafficPro.includesTag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
              {t('trafficPro.includesTitle')}{' '}
              <span className="text-primary-500">{t('trafficPro.includesTitleHighlight')}</span>
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {INCLUDES_ITEMS.map((item, i) => (
            <ScrollReveal key={item.key} delay={i * 0.06}>
              <div className="group bg-white border border-gray-100 rounded-2xl p-6 hover:border-primary-200 hover:shadow-[0_8px_40px_rgba(0,0,0,0.06)] hover:-translate-y-1 transition-all duration-400">
                <div className="w-11 h-11 rounded-xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors duration-300">
                  <i className={`${item.icon} text-primary-500 text-xl`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-950 mb-2">
                  {t(`trafficPro.${item.key}`)}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {t(`trafficPro.${item.key}Desc`)}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}